import { useMemo } from 'react';
import { getCssVariables } from '../utils/getCssVariables';

/**
 * Custom hook to extract CSS color variables for charts
 * Uses the existing getCssVariables utility with React memoization
 * 
 * @param {...string} colorVars - CSS variable names (e.g., '--emerald-600')
 * @returns {Object} Object with color values keyed by variable name (without --)
 * 
 * @example
 * const colors = useChartColors('--emerald-600', '--ruby-400');
 * // Returns: { 'emerald-600': '#059669', 'ruby-400': '#f87171' }
 */
export const useChartColors = (...colorVars) => {
  return useMemo(() => {
    return getCssVariables(...colorVars);
  }, [colorVars.join(',')]);
};
